import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { JobMatchAction } from 'src/app/core/models/jobMatchAction';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { JobService } from 'src/app/core/services/job.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { FourDotFiveDateFormatPipe } from 'src/app/core/pipes/four-dot-five-date-format.pipe';
import { CompareAndUpdateCandidateDetailsModalComponent } from '../compare-and-update-candidate-details/compare-and-update-candidate-details-modal/compare-and-update-candidate-details-modal.component';
import { UploadResumesActionsModalComponent } from '../upload-resumes/upload-resumes-actions-modal/upload-resumes-actions-modal.component';
import { UploadResumesTransactionCandidatesModalComponent } from '../upload-resumes/upload-resumes-transaction-candidates-modal/upload-resumes-transaction-candidates-modal.component';
import { JobMatchActionsService } from 'src/app/core/services/job-match-actions.service';
import { AuthService } from 'src/app/core/services/auth.service';

declare var $: any;
declare var bootbox: any;
declare var libphonenumber: any;

@Component({
  selector: 'app-upload-single-resume',
  templateUrl: './upload-single-resume.component.html'
})
export class UploadSingleResumeComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DropzoneDirective) resumeUploadDropzoneDirective: DropzoneDirective;

  @Input() jobId;
  @Input() candidateId;
  @Input() controlObject: any;
  @Input() context;
  @Input() formalizeActivityPayload;
  @Input() sourceScreen;
  @Output() cancelCallback = new EventEmitter<void>();
  @Output() candidateProcessedCallback = new EventEmitter<void>();
  @Output() completeCallback = new EventEmitter<void>();

  MESSAGECONSTANTS = MESSAGECONSTANTS;

  defaultJobSourceTypeId: any;
  sourceTypeList: any[] = [];
  resumeList: any[] = [];
  sourceType: any = null;
  sourceTypeId: any = null;
  otherSourceTypeNotes: any = null;
  referrerName: any = null;
  referrerEmail: any = null;
  uploadResumesResponse: any = null;
  totalUploads: any = null;
  candidatesList: any[] = [];
  candidatesToAssociateList: any[] = [];
  candidateCount: any = null;
  createJobMatchesObject: any = null;
  activityMap: any[] = [];
  candidateDetailsToUpdate: any;
  fetchOldCandidateDetails: any;

  showCandidateUpdateFailureMessage = false;
  isSingleCandidateUpload = false;
  disableUploadButtonFlag = true;
  fileExistsFlag = false;
  disablePreviousButtonFlag = false;
  disableNextButtonFlag = true;
  disableCancelButtonFlag = false;
  fileUploadInProgressFlag = false;
  mandatoryFieldsError = false;
  disableSourceTypesFlag = false;
  resumeScoringDoneFlag = false;
  scoringCandidatesFlag = false;
  gettingCountsFlag = false;
  jobContextExistsFlag = false;
  associatingCandidatesFlag = false;
  selectedAllCandidatesFlag = false;
  displaySelectDeselectButtonFlag = true;
  additionalMatchRuleVerifiedCopy = false;
  additionalMatchRuleVerificationPassedCopy = false;
  isDirectCandidateUpdate = true;

  uploadResumesWizard: any;
  resumeUploadDropzone: any;
  dropzoneConfig: DropzoneConfigInterface;

  private cancelUploadResumeSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private jobMatchActionsService: JobMatchActionsService,
    private bsModalService: BsModalService,
    private angularModalService: AngularModalService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private resumeService: ResumeService,
    private jobMatchService: JobMatchService,
    private candidateService: CandidateService,
    private jobService: JobService,
    private utilityService: UtilityService,
    private fourDotFiveDateFormatPipe: FourDotFiveDateFormatPipe
  ) { }

  ngOnInit() {
    this.initVariables();

    this.cancelUploadResumeSubscription = this.resumeService.cancelUploadResume.subscribe(() => {
      this.cancelUploadResumes();
    });

    if (this.candidateId !== '') {
      this.isSingleCandidateUpload = true;
    }
    if (this.jobId !== null && this.jobId !== undefined && this.jobId != '') {
      this.jobContextExistsFlag = true;
      this.createJobMatchesObject = {
        companyId: this.authService.userDetails.company.companyId,
        requisitionId: this.jobId,
        candidateIds: [],
        manuallyMatchedFromUI: true,
        transactionId: null,
        isAssociateCandidate: false,
        overrideNoteDetails: []
      };
    }
    this.resumeList = [];
    this.getAllSourceTypes(() => {
      if (this.jobId !== null && this.jobId !== undefined && this.jobId != '') {
        this.getLastAddedCandidateSourceTypeId();
      }
    });
    this.dropzoneConfig = this._getDropZoneSettings();
    setTimeout(() => {
      this.uploadResumesWizard = this.createUploadResumeWizard();
    }, 300);
    this.getAllActivityTypes();
  }

  ngAfterViewInit() {
    const dropzoneElement = document.querySelector('form#resumeUploadDropzone');
    if (dropzoneElement) {
      this.resumeUploadDropzone = this.resumeUploadDropzoneDirective.dropzone();
    }
  }

  ngOnDestroy() {
    if (this.cancelUploadResumeSubscription) {
      this.cancelUploadResumeSubscription.unsubscribe();
    }
  }

  initVariables() {
    this.sourceTypeList = [];
    this.resumeList = [];
    this.sourceType = null;
    this.sourceTypeId = null;
    this.otherSourceTypeNotes = null;
    this.referrerName = null;
    this.referrerEmail = null;
    this.uploadResumesResponse = null;
    this.totalUploads = null;
    this.candidatesList = [];
    this.candidatesToAssociateList = [];
    this.candidateCount = null;
    this.createJobMatchesObject = null;
    this.showCandidateUpdateFailureMessage = false;
    this.isSingleCandidateUpload = false;
    this.disableUploadButtonFlag = true;
    this.fileExistsFlag = false;
    this.disablePreviousButtonFlag = false;
    this.disableNextButtonFlag = true;
    this.disableCancelButtonFlag = false;
    this.fileUploadInProgressFlag = false;
    this.mandatoryFieldsError = false;
    this.disableSourceTypesFlag = false;
    this.resumeScoringDoneFlag = false;
    this.scoringCandidatesFlag = false;
    this.gettingCountsFlag = false;
    this.jobContextExistsFlag = false;
    this.associatingCandidatesFlag = false;
    this.selectedAllCandidatesFlag = false;
    this.displaySelectDeselectButtonFlag = true;
    this.additionalMatchRuleVerifiedCopy = false;
    this.additionalMatchRuleVerificationPassedCopy = false;
    this.isDirectCandidateUpdate = true;
  }

  getAllActivityTypes() {
    this.activityMap = [];
    this.jobService.getActivityTypes((data) => {
      data.forEach(val => {
        this.activityMap[val.value] = val.name;
      });
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    });
  }

  getLastAddedCandidateSourceTypeId() {
    this.jobService.getLastAddedCandidateSourceTypeId(this.jobId, (data) => {
      this.defaultJobSourceTypeId = data.lastAddedCandidateSourceTypeId;
      this._setDefaultSourceType();
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  onFileAdded() {
    this.fileExistsFlag = true;
    this.updateActionButtons();
    $('.dz-progress').css({ top: '70%' });
  }

  onFileRemoved(file) {
    if (file.resumeId !== undefined) {
      this.candidateService.deleteCandidateOnResumeRemove(file.resumeId, () => {
        _.remove(this.resumeList, {
          resumeId: file.resumeId
        });
        _.remove(this.uploadResumesResponse.files, {
          resumeId: file.resumeId
        });
        this.uploadResumesResponse.successCount = this.uploadResumesResponse.successCount - 1;
        this.totalUploads = this.totalUploads - 1;
        if (this.resumeUploadDropzone.files.length === 0) {
          this.fileExistsFlag = false;
          $('.dz-hidden-input').prop('disabled', false);
        }
        this.updateActionButtons();
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else {
      if (this.resumeUploadDropzone.files.length === 0) {
        this.fileExistsFlag = false;
        $('.dz-hidden-input').prop('disabled', false);
      }
      this.updateActionButtons();
    }
  }

  onFileSendingMultiple(args) {
    const formData = args[2];
    this.disableUploadButtonFlag = true;
    this.disableSourceTypesFlag = true;
    this.fileUploadInProgressFlag = true;
    const resumeUpload: any = {};
    resumeUpload.companyId = this.authService.userDetails.company.companyId;
    resumeUpload.userId = this.authService.userDetails.id;
    resumeUpload.resumeSourceTypeId = this.sourceTypeId;
    resumeUpload.buIdList = [];
    formData.append('companyId', resumeUpload.companyId);
    formData.append('resumeSourceTypeId', resumeUpload.resumeSourceTypeId);
    formData.append('userId', resumeUpload.userId);
    formData.append('buIdList', resumeUpload.buIdList);
    if (this.sourceType.sourceType == 'Other') {
      formData.append('otherSourceTypeNotes', this.otherSourceTypeNotes);
    } else {
      formData.append('otherSourceTypeNotes', null);
    }
    if (this.sourceType.sourceType == 'Referral') {
      formData.append('referrerName', this.referrerName);
      formData.append('referrerEmail', this.referrerEmail);
    } else {
      formData.append('referrerName', null);
      formData.append('referrerEmail', null);
    }
    if (this.jobId !== null) {
      formData.append('jobId', this.jobId);
    }
    if (this.candidateId && this.candidateId != '') {
      formData.append('candidateId', this.candidateId);
    }
  }

  onFileSuccessMultiple(args) {
    const fileArray = args[0];
    const response = args[1];
    this.fileUploadInProgressFlag = false;
    this.uploadResumesResponse = response;
    if (this.jobContextExistsFlag) {
      this.createJobMatchesObject.transactionId = this.uploadResumesResponse.transactionID;
    }
    this.totalUploads = response.successCount + response.failureCount;
    if (response.files !== undefined && response.files.length > 0) {
      response.files.forEach((val, key) => {
        fileArray[key].resumeId = val.resumeId;
        if (val.isSuccess) {
          this.resumeList.push(val);
        }
      });
    }
    if (this.uploadResumesResponse.conflicts) {
      if (this.uploadResumesResponse.conflicts.disallowUpload) {
        this.alertsAndNotificationsService.showAlertWithCallBack('Upload Failed', this.uploadResumesResponse.conflicts.uploadBlockedMessage, 'danger', () => {
          if (this.cancelCallback) {
            this.cancelCallback.emit();
          }
        });
      } else if (!this.uploadResumesResponse.conflicts.disallowUpload && this.uploadResumesResponse.conflicts.conflictExists) {
        this._showConflictsModal(this.uploadResumesResponse.conflicts);
      }
    } else {
      const message = response.message ? response.message : this.MESSAGECONSTANTS.NOTIFICATIONS.UPLOAD.RESUME_UPLOAD_SUCCESS;
      this.alertsAndNotificationsService.showBannerMessage(message, 'success');
      if (this.cancelCallback) {
        this.cancelCallback.emit();
      }
    }
    this.updateActionButtons();
    $('.dz-hidden-input').prop('disabled', true);
  }

  onFileError(args) {
    const file = args[0];
    const error = args[1];
    const elements = document.querySelectorAll('.dz-file-preview');
    elements.forEach((element: any) => {
      const filename = element.querySelectorAll('.dz-filename span')[0].textContent;
      const errorMessage = element.querySelectorAll('.dz-error-message span')[0];
      if (filename === file.name) {
        errorMessage.textContent = error.message == undefined ? error : error.message;
      }
    });
    this.disableNextButtonFlag = false;
  }

  _getDropZoneSettings(): DropzoneConfigInterface {
    let maxFilesToUpload = 100;
    if (this.isSingleCandidateUpload) {
      maxFilesToUpload = 1;
    }
    const dropZoneSettings: any = {
      url: this.resumeService.getUploadUrl(),
      paramName: () => 'file',
      acceptedFiles: '.pdf,.xlsx,.docx,.doc',
      maxFiles: maxFilesToUpload,
      maxFilesize: 10,
      maxThumbnailFilesize: 10,
      timeout: 300000,
      addRemoveLinks: true,
      autoProcessQueue: false,
      uploadMultiple: true,
      parallelUploads: 100
    };
    return dropZoneSettings;
  }

  createUploadResumeWizard() {
    const uploadResumesWizard = $('#uploadResumesWizard').wizard();

    $('#uploadResumesWizard').on('actionclicked.fu.wizard', (evt, data) => {
      if (data.direction == 'next') {
        switch (data.step) {
          case 1:
            $('.dz-remove').remove();
            if (!this.resumeScoringDoneFlag) {
              this.disableNextButtonFlag = true;
              this.disablePreviousButtonFlag = true;
              this.scoringCandidatesFlag = true;
              if (!this.isSingleCandidateUpload) {
                this._runScoringForResumes();
              } else {
                this.runResumeScoringForAssociate(null, null);
              }
            } else {
              this._getCandidateCounts();
            }
            break;
          default:
            break;
        }
      } else if (data.direction == 'previous') {
        if (data.step == 2) {
          this.updateActionButtons();
        }
      }
    });

    $('#uploadResumesWizard').on('finished.fu.wizard', () => {
      if (this.jobContextExistsFlag) {
        if (this.candidatesToAssociateList.length != 0) {
          this.associateCandidates(() => {
            if (this.completeCallback) {
              this.completeCallback.emit();
            }
          });
        } else {
          if (this.completeCallback) {
            this.completeCallback.emit();
          }
        }
      } else {
        if (this.completeCallback) {
          this.completeCallback.emit();
        }
      }
    });

    return uploadResumesWizard;
  }

  _runScoringForResumes() {
    let jobId = null;
    if (this.jobId !== '' && this.jobId !== undefined && this.jobId !== null) {
      jobId = this.jobId;
    }
    this.resumeService.runResumesForScoring(this.uploadResumesResponse, jobId, (data) => {
      data.forEach(val => {
        if (_.isNull(val.firstName)) {
          val.firstName = '-';
        }
        if (_.isNull(val.lastName)) {
          val.lastName = '-';
        }
        if (_.isNull(val.email)) {
          val.email = '-';
        }
        if (_.isNull(val.phone)) {
          val.phone = '-';
        }
        val.name = val.firstName + ' ' + val.lastName;
        if (val.mobilePhoneCountryCodePresent) {
          const phoneNumberObject = libphonenumber.parse(val.phone.toString());
          if (phoneNumberObject.phone !== undefined) {
            val.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
          }
        }
        val.score = Math.floor(parseFloat(val.score));
        val.selectedFlag = false;
        if (val.score >= val.jobThresholdScore) {
          val.intelligenceScorePassFlag = true;
        }
        this.candidatesList.push(val);
      });
      this.scoringCandidatesFlag = false;
      this.resumeScoringDoneFlag = true;
      this.disableNextButtonFlag = false;
      this.disablePreviousButtonFlag = false;
      if (this.candidateProcessedCallback) {
        this.candidateProcessedCallback.emit();
      }
      this._getCandidateCounts();
    }, () => {
    });
  }

  runResumeScoringForAssociate(contactDetails, type) {
    let isUpdate = false;
    if (contactDetails) {
      isUpdate = (type && type === 'save') ? true : false;
      this.uploadResumesResponse.candidateContactDetail = contactDetails;
    }
    this.uploadResumesResponse.file = this.uploadResumesResponse.files[0];
    this.utilityService.showLoadingModal('Saving...');
    this.resumeService.runResumeScoringForAssociate(this.uploadResumesResponse, this.candidateId, this.jobId, isUpdate, (data) => {
      this.utilityService.hideLoadingModal();
      if (!this.isSingleCandidateUpload) {
        this.candidateDetailsToUpdate = data;
        if (!isUpdate) {
          this.additionalMatchRuleVerifiedCopy = this.candidateDetailsToUpdate.additionalMatchRuleVerified;
          this.additionalMatchRuleVerificationPassedCopy = this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed;
        }
        const fetchNewCandidateDetails = {
          firstName: this.candidateDetailsToUpdate.candidateConflictDetails[0].newValue,
          lastName: this.candidateDetailsToUpdate.candidateConflictDetails[1].newValue,
          email: this.candidateDetailsToUpdate.candidateConflictDetails[2].newValue,
          phoneNumber: this.candidateDetailsToUpdate.candidateConflictDetails[3].newValue
        };
        this.fetchOldCandidateDetails = {
          firstName: this.candidateDetailsToUpdate.candidateConflictDetails[0].oldValue,
          lastName: this.candidateDetailsToUpdate.candidateConflictDetails[1].oldValue,
          email: this.candidateDetailsToUpdate.candidateConflictDetails[2].oldValue,
          phoneNumber: this.candidateDetailsToUpdate.candidateConflictDetails[3].oldValue
        };

        if (this.candidateDetailsToUpdate.candidateUpdated) {
          if (!isUpdate) {
            this.isDirectCandidateUpdate = true;
          }
          this.scoringCandidatesFlag = false;
          this.resumeScoringDoneFlag = true;
          this.disableNextButtonFlag = false;
          this.disablePreviousButtonFlag = false;
          this.candidatesList.push(fetchNewCandidateDetails);
        } else if (this.candidateDetailsToUpdate.candidateConflicts) {
          this.isDirectCandidateUpdate = false;
          this.showCandidateUpdateFailureMessage = true;
          this.scoringCandidatesFlag = false;
          this.resumeScoringDoneFlag = true;
          this.disableNextButtonFlag = false;
          this.disablePreviousButtonFlag = false;
          if (isUpdate) {
            this.candidateDetailsToUpdate.additionalMatchRuleVerified = this.additionalMatchRuleVerifiedCopy;
            this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed = this.additionalMatchRuleVerificationPassedCopy;
          }
        } else {
          this.isDirectCandidateUpdate = false;
          this._showConflictsModal(this.candidateDetailsToUpdate);
        }
        if (this.candidateProcessedCallback) {
          this.candidateProcessedCallback.emit();
        }
      } else {
        if (type && type === 'save') {
          this.alertsAndNotificationsService.showAlertWithCallBack('Success', 'Candidate details updated successfully.', 'success', () => {
          });
        } else if (type && type === 'cancel') {
          this.alertsAndNotificationsService.showAlertWithCallBack('Update Cancelled', 'Candidate update cancelled. No changes were made to the candidate details.', 'info', () => {
          });
        }
        if (this.completeCallback) {
          this.completeCallback.emit();
        }
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      if (this.completeCallback) {
        this.completeCallback.emit();
      }
      this.utilityService.hideLoadingModal();
    });
  }

  private _showConflictsModal(candidateConflictDetails) {
    this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      let bsModalRef: BsModalRef;
      const config = new ModalConfig();
      config.class = 'four-dot-five-modal-medium';
      config.initialState = {
        resolve: {
          candidateConflictDetails
        },
        modalInstance: {
          close: (callbackObject) => {
            bsModalRef.hide();
            if (callbackObject.callbackType == 'save') {
              this.runResumeScoringForAssociate(callbackObject.entity, 'save');
            } else if (callbackObject.callbackType == 'cancel') {
              if (this.isSingleCandidateUpload) {
                this.runResumeScoringForAssociate(callbackObject.entity, 'cancel');
              } else {
                this.scoringCandidatesFlag = false;
                this.resumeScoringDoneFlag = true;
                this.disableNextButtonFlag = false;
                this.disablePreviousButtonFlag = false;
                this.candidatesList = [];
                this.candidatesList.push(this.fetchOldCandidateDetails);
              }
            } else {
              this.scoringCandidatesFlag = false;
              this.resumeScoringDoneFlag = true;
              this.disableNextButtonFlag = false;
              this.disablePreviousButtonFlag = false;
              this.candidatesList = [];
              this.candidatesList.push(this.fetchOldCandidateDetails);
            }
          },
          dismiss: () => {
            bsModalRef.hide();
          }
        }
      };
      bsModalRef = this.bsModalService.show(CompareAndUpdateCandidateDetailsModalComponent, config);
    }, 300);
  }

  cancelUploadResumes() {
    let message = 'Are you sure you want to cancel ?';
    let showPopUp = true;
    let createCandidatesFlag = false;
    if (this.resumeScoringDoneFlag) {
      // do nothing.
    } else {
      if (this.resumeList.length) {
        message = 'No job matches will be created for the uploaded candidate(s).<br>Do you still want to continue?';
        createCandidatesFlag = true;
      } else if (this.resumeUploadDropzone.files.length > 0) {
        message = 'Are you sure you want to cancel ?<br>Un-uploaded files exist in the upload area.';
      } else {
        showPopUp = false;
      }
    }
    if (showPopUp) {
      bootbox.confirm({
        closeButton: false,
        title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
        message,
        className: 'zIndex1060',
        backdrop: true,
        onEscape: false,
        buttons: {
          confirm: {
            label: 'Yes',
            className: 'btn-info'
          },
          cancel: {
            label: 'Cancel',
            className: 'btn-danger'
          }
        },
        callback: (result) => {
          const dialogMessage = "<p class='text-center'>Creating candidate(s) for uploaded resume(s) <i class='fa fa-spinner fa-spin'></i><br>Please go to Candidates screen to view the candidate(s).</p>";
          if (result) {
            if (createCandidatesFlag) {
              const createUploadedCandidatesDialog = bootbox.dialog({
                message: dialogMessage,
                closeButton: false
              });
              this.resumeService.runResumesWithoutScoring(this.uploadResumesResponse, this.jobId, () => {
                createUploadedCandidatesDialog.modal('hide');
                this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                if (this.cancelCallback) {
                  this.cancelCallback.emit();
                }
              }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
              });
            } else {
              if (this.cancelCallback) {
                this.cancelCallback.emit();
              }
            }
          } else {
            this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          }
        }
      });
    } else {
      if (this.cancelCallback) {
        this.cancelCallback.emit();
      }
    }
  }

  updateActionButtons() {
    if (this.resumeList.length > 0) {
      this.disableSourceTypesFlag = true;
      this.resumeUploadDropzone.clickable = false;
      this.disableUploadButtonFlag = true;
      this.disableNextButtonFlag = false;
    } else {
      if (this.fileExistsFlag) {
        if (!_.isNull(this.sourceTypeId)) {
          this.disableUploadButtonFlag = false;
        } else {
          this.disableUploadButtonFlag = true;
        }
      } else {
        this.disableUploadButtonFlag = true;
        this.disableSourceTypesFlag = false;
      }
      this.disableNextButtonFlag = true;
    }
  }

  candidateToAssociateToggle(candidate) {
    if (candidate.selectedFlag) {
      this.candidatesToAssociateList.push(candidate);
    } else {
      _.remove(this.candidatesToAssociateList, {
        candidateId: candidate.candidateId
      });
      _.remove(this.createJobMatchesObject.overrideNoteDetails, {
        candidateId: candidate.candidateId
      });
    }
  }

  associateCandidates(successCallback?) {
    this.candidatesToAssociateList.forEach(val => {
      this.createJobMatchesObject.candidateIds.push(val.candidateId);
    });
    this.associatingCandidatesFlag = true;
    const associatingDialog = bootbox.dialog({
      message: '<p class="text-center">Adding Candidates <i class="fa fa-spinner fa-spin"></i></p>',
      closeButton: false
    });
    this.createJobMatchesObject.isAddCandidate = true;
    this.jobMatchService.createJobMatches(this.createJobMatchesObject, () => {
      this.associatingCandidatesFlag = false;
      associatingDialog.modal('hide');
      this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      this.candidatesToAssociateList.forEach(val => {
        const index = this.candidatesList.findIndex(c => c.candidateId === val.candidateId);
        this.candidatesList[index].candidateMatchedToJob = true;
        this.candidatesList[index].statusOfJobMatch = 'Candidate Added.';
        this.candidatesList[index].selectedFlag = false;
      });
      this.candidatesToAssociateList = [];
      this._getCandidateCounts();
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.associatingCandidatesFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _getCandidateCounts() {
    this.gettingCountsFlag = true;
    this.resumeService.getCandidateCount(this.uploadResumesResponse.transactionID, (data) => {
      this.candidateCount = data;
      if (this.candidateCount.unMatchedCandidateCount == 0) {
        this.displaySelectDeselectButtonFlag = false;
      }
      this.updateActionButtons();
      this.gettingCountsFlag = false;
    }, (error) => {
      this.gettingCountsFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  displayCandidates(countType) {
    setTimeout(() => {
      let bsModalRef: BsModalRef;
      const config = new ModalConfig();
      config.class = 'upload-resumes-candidates-modal-large';
      config.initialState = {
        resolve: {
          countsObject: this.candidateCount,
          countType,
          activityMap: this.activityMap
        },
        modalInstance: {
          close: () => {
            bsModalRef.hide();
            this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          },
          dismiss: () => {
            bsModalRef.hide();
            this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          }
        }
      };
      bsModalRef = this.bsModalService.show(UploadResumesTransactionCandidatesModalComponent, config);
    }, 300);
  }

  showOverrideCandidateSuspensionModal(candidate) {
    const candidateId = candidate.candidateId;
    const candidateName = candidate.name;
    const suspendedMonths = candidate.overrideFor === 'RELEASE' ? candidate.releasedCandidateDetailDTO.numberOfMonthsToWait : candidate.jobLeftCandidateDetailDTO.numberOfMonthsToWait;
    const releaseDate = candidate.overrideFor === 'RELEASE' ? candidate.releasedCandidateDetailDTO.releasedAt : candidate.jobLeftCandidateDetailDTO.leftAt;
    const allowOverride = candidate.allowOverride;
    const releasedJobDetails = candidate.overrideFor === 'RELEASE' ? candidate.releasedCandidateDetailDTO : candidate.jobLeftCandidateDetailDTO;
    const type = candidate.overrideFor === 'RELEASE' ? 'release' : 'jobLeft';

    if (allowOverride) {
      setTimeout(() => {
        let bsModalRef: BsModalRef;
        const config = new ModalConfig();
        config.class = 'custom-modal-xl';
        config.initialState = {
          resolve: {
            candidateId,
            candidateName,
            suspendedMonths,
            releaseDate,
            allowOverride,
            releasedJobDetails,
            type
          },
          modalInstance: {
            close: (callbackObject) => {
              bsModalRef.hide();
              if (callbackObject.callbackType == 'save') {
                const index = this.candidatesList.findIndex(c => c.candidateId === candidate.candidateId);
                this.createJobMatchesObject.overrideNoteDetails.push(callbackObject.entity);
                this.candidatesList[index].allowManualMatch = true;
                this.candidatesList[index].showOverride = false;
                this.candidatesList[index].statusOfJobMatch = 'Candidate is made available for matching.';
                this.candidatesList[index].selectedFlag = true;
                this.candidateToAssociateToggle(this.candidatesList[index]);
              }
            },
            dismiss: () => {
              bsModalRef.hide();
            }
          }
        };
        bsModalRef = this.bsModalService.show(UploadResumesActionsModalComponent, config);
      }, 300);
    } else {
      let displayHtmlText = '';
      if (type == 'release') {
        displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
        displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.fourDotFiveDateFormatPipe.transform(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
      } else {
        displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
        displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.fourDotFiveDateFormatPipe.transform(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
      }

      bootbox.alert({
        closeButton: false,
        title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot add candidate</strong></div>",
        message: displayHtmlText,
        className: 'zIndex1060',
        buttons: {
          ok: {
            label: 'Ok',
            className: 'btn-info'
          }
        },
        callback: () => {
          this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }
      });
    }
  }

  getAllSourceTypes(successCallback) {
    this.resumeService.getAllSourceTypes((data) => {
      this.sourceTypeList = data;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    });
  }

  private _setDefaultSourceType() {
    if (this.defaultJobSourceTypeId !== undefined && this.defaultJobSourceTypeId !== '' && !_.isNull(this.defaultJobSourceTypeId)) {
      const index = this.sourceTypeList.findIndex((sourceType) => sourceType.id == this.defaultJobSourceTypeId);
      if (index !== -1) {
        this.sourceType = this.sourceTypeList[index];
        this.sourceTypeId = this.sourceType.id;
      }
    }
  }

  sourceTypeChanged() {
    if (this.sourceType !== undefined && this.sourceType.id !== undefined) {
      this.sourceTypeId = this.sourceType.id;
      this.updateActionButtons();
    } else {
      this.sourceTypeId = null;
    }
  }

  uploadResumes(uploadResumesForm) {
    if (uploadResumesForm.valid) {
      this.resumeUploadDropzone.processQueue();
    }
  }

  toggleSelectAllCandidates() {
    if (this.selectedAllCandidatesFlag) {
      this.candidatesList.forEach(val => {
        if (!val.candidateMatchedToJob && val.selectedFlag && val.allowManualMatch) {
          val.selectedFlag = false;
          _.remove(this.candidatesToAssociateList, {
            candidateId: val.candidateId
          });
        }
      });
      this.selectedAllCandidatesFlag = false;
    } else {
      this.candidatesList.forEach(val => {
        if (!val.candidateMatchedToJob && !val.selectedFlag && val.allowManualMatch) {
          val.selectedFlag = true;
          this.candidatesToAssociateList.push(val);
        }
      });
      this.selectedAllCandidatesFlag = true;
    }
  }

  jobCompare(candidate) {
    const actionObject = new JobMatchAction('Candidate Job Comparison', 'CANDIDATE_JOB_COMPARE', true, null);
    candidate.id = candidate.candidateId;
    candidate.jobMatchJobId = this.jobId;
    this.jobMatchActionsService.performAction('uploadResumes', actionObject, candidate, () => {
    }, () => {
    });
  }

  receiveFormalizedComment(event) {
    this.otherSourceTypeNotes = event;
  }

  onVoiceTranscript(transcript) {
    if (this.otherSourceTypeNotes) {
      this.otherSourceTypeNotes += ' ' + transcript;
    } else {
      this.otherSourceTypeNotes = transcript;
    }
  }
}
